import HeaderCircleK from '../../../../customized/circle-k/theme/ui/Layout/Header/Header';
import { ToggleComponent } from '../../../../shared/featureToggle';
import Header from './Header';

export default ToggleComponent(Header, {
  StyledComponentsVariants: {
    'circle-k': HeaderCircleK,
  },
});
